import { render } from "./personnel.vue?vue&type=template&id=74e676b4&scoped=true&ts=true"
import script from "./personnel.vue?vue&type=script&lang=ts"
export * from "./personnel.vue?vue&type=script&lang=ts"

import "./personnel.vue?vue&type=style&index=0&id=74e676b4&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74e676b4"]])

export default __exports__